// Copyright (c) 2025 GeoVerses. All rights reserved.

import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';

const EmailVerificationDialog = ({ open, unverifiedUser, resendMessage, onResend, onClose }) => (
  <Dialog open={open} disableEscapeKeyDown>
    <DialogTitle>Verify Your Email</DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        A verification email has been sent to <strong>{unverifiedUser?.firebaseUser?.email}</strong>. Please check your inbox and verify your email before signing in.
      </Typography>
      {resendMessage && (
        <Typography variant="body2" color={resendMessage.includes('sent') ? 'success.main' : 'error'} sx={{ mb: 1 }}>
          {resendMessage}
        </Typography>
      )}
      <Button size="small" onClick={onResend}>
        Resend verification email
      </Button>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={onClose}>OK</Button>
    </DialogActions>
  </Dialog>
);

export default EmailVerificationDialog;
